import { FlexColumn } from '@/atoms/FlexContainers'
import { CaptionMD, TitleSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface ExpressHeaderProps {
  projectName: string
  isDarkMode: boolean
}

export const ExpressHeader = ({ projectName, isDarkMode }: ExpressHeaderProps) => {
  const { t } = useTranslate('pif')
  return (
    <FlexColumn className="gap-6">
      <FlexColumn className="items-center text-center">
        <CaptionMD italic color={isDarkMode ? 'core-gray-400' : 'core-gray-800'}>
          {projectName}
        </CaptionMD>
        <TitleSM weight="bold" className="mt-2 text-balance" color={isDarkMode ? 'white' : 'core-gray-950'}>
          {t(
            'helpOthersExperienceThisMovieForFreeByContributingPif',
            'Help others experience this movie for free by contributing to Pay it Forward.',
          )}
        </TitleSM>
      </FlexColumn>
    </FlexColumn>
  )
}
